import React from 'react'
import {connect} from 'react-redux'
import {submitSignIn} from './actions'
import SignIn from './views'

// the service props are provides by the parent "Onboarding" component
export const Registration = ({gov_care_registration, record_type, id, submitSignIn, tokens}) => {
  const {
    loading,
    errors
  } = gov_care_registration

  return (
    <SignIn
      id={id}
      record_type={record_type}
      loading={loading}
      errors={errors}
      submitAction={submitSignIn}
      tokens={tokens}
    />
  )
}

const mapStateToProps = (state) => ({
  tokens: {
    jwt: state.authorisation.jwt
  }
})

const mapDispatchToProps = (dispatch) => ({
  submitSignIn: (params) => {
    dispatch(submitSignIn(params))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Registration)



// WEBPACK FOOTER //
// ./src/registration/container.jsx